import React, { useEffect, useState } from 'react';
import { Button, Modal, Space, Table, Typography, message } from 'antd';
import { CheckOutlined, ReloadOutlined } from '@ant-design/icons';
import moment from 'moment';
import { authAPI } from '../services/api';

const { Title, Text } = Typography;

const UserApproval = () => {
  const [loading, setLoading] = useState(false);
  const [approvingId, setApprovingId] = useState(null);
  const [data, setData] = useState([]);

  const fetchData = async () => {
    setLoading(true);
    try {
      const resp = await authAPI.pendingUsers();
      setData(resp.data || []);
    } catch (e) {
      message.error(e?.response?.data?.detail || '获取待审批用户失败');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleApprove = (record) => {
    if (!record?.id) return;
    Modal.confirm({
      title: '确认审批',
      content: (
        <div>
          <div>{`确定要审批通过用户“${record.username || record.id}”吗？`}</div>
          <div style={{ color: 'red', marginTop: 8 }}>
            此操作无法撤销，审批通过后该用户将可以登录系统。
          </div>
        </div>
      ),
      okText: '确认审批',
      cancelText: '取消',
      okButtonProps: { danger: true },
      onOk: async () => {
        setApprovingId(record.id);
        try {
          const resp = await authAPI.approveUser(record.id);
          const ok = !!resp?.data?.ok;
          if (ok) {
            message.success('审批成功');
          } else {
            message.error('审批失败');
          }
          await fetchData();
        } catch (e) {
          message.error(e?.response?.data?.detail || '审批失败');
        } finally {
          setApprovingId(null);
        }
      },
    });
  };

  const columns = [
    { title: 'ID', dataIndex: 'id', key: 'id', width: 90 },
    { title: '用户名', dataIndex: 'username', key: 'username', width: 180 },
    { title: '邮箱', dataIndex: 'email', key: 'email', width: 220, render: (v) => v || '-' },
    {
      title: '创建时间',
      dataIndex: 'created_at',
      key: 'created_at',
      width: 180,
      render: (v) => (v ? moment.utc(v).utcOffset(8).format('YYYY-MM-DD HH:mm:ss') : '-'),
    },
    {
      title: '操作',
      key: 'action',
      fixed: 'right',
      width: 160,
      render: (_, record) => (
        <Space>
          <Button
            type="link"
            icon={<CheckOutlined />}
            loading={approvingId === record.id}
            onClick={() => handleApprove(record)}
          >
            审批通过
          </Button>
        </Space>
      ),
    },
  ];

  return (
    <div>
      <Space direction="vertical" size={12} style={{ width: '100%' }}>
        <div>
          <Title level={3} style={{ margin: 0 }}>用户审批</Title>
          <Text type="secondary">新注册用户默认不可登录，需要管理员审批后才可登录。</Text>
        </div>

        <div>
          <Button icon={<ReloadOutlined />} onClick={fetchData} loading={loading}>
            刷新
          </Button>
        </div>

        <Table
          columns={columns}
          dataSource={data}
          rowKey="id"
          loading={loading}
          scroll={{ x: 900 }}
          pagination={{ pageSize: 20 }}
        />
      </Space>
    </div>
  );
};

export default UserApproval;
